module.exports = __webpack_public_path__ + "static/media/shades.0a3b6ff1.jpg";